import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function OptionKeyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const answer: string = control.controlData.optionKey;
    const value: string = control.value?.toString();
    if(!value) {
      control.setErrors({ challenge: true });
      return { challenge: true };
    }

    const match = answer.trim().toLowerCase() === value.trim().toLowerCase();

    if (match) {
      control.setErrors(null);
      return null;
    } else {
      control.setErrors({ challenge: true });
      return { challenge: true };
    }
  };
}

